export const GOT_VEHICLE = 'got-vehicle';
const gotVehicle = ({ vehicle }) => ({
  type: GOT_VEHICLE,
  payload: { vehicle },
});
export default gotVehicle;
